import "../ChatBox/Chatbox.scss";
import user from "../../assets/img/user.png";
import user2 from "../../assets/img/user2.png";
import attachment from "../../assets/img/attachment.svg";
import btn_submit from "../../assets/img/btn_submit.svg";
import loading_gif from "../../assets/img/745.gif";
import close_icon from "../../assets/img/106830.png";
import loading_circle from "../../assets/img/1488.gif";
import external_link from "../../assets/img/external-link-symbol.png";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Markdown from "react-markdown";
import ConversionModal from "../Modals/ConversionModal";
import Button from "react-bootstrap/Button";
import moment from "moment";
import subAgent from "../../assets/img/subagent.svg";
import ConvList from "../LeftPannel/ConvList";
import Accordion from "./Accordion";
import packageJson from '../../../package.json';
import PromptTemplatesModal from '../Modals/PromptTemplatesModal';

// const header = {
//   authorization:
//     "6892a6cb-93d6-4500-99d4-e028c7f8c3dd:sk-ZmIyMmQzZTktZThlYi00MTk5LWFhY2UtY2JhNmI1ZGMzNGU3",
// };
export default function Chatbox() {
  const [isInitial, setIsInitial] = useState(true);
  const [data, setData] = useState<any>([]);
  const [question, setQuestion] = useState("");
  const [questionList, setQuestionList] = useState([]);
  const [jobId, setJobId] = useState("");
  const [loading, setLoading] = useState(false);
  const [conversationId, setConversationId] = useState("");
  const [isCreateTask, setIsCreateTask] = useState(false);
  const [file, setFile] = useState<any>();
  const [activeConv, setActiveConv] = useState<any>("");
  const [currentConv, setCurrentConv] = useState<any>("");
  const lastMessageRef = useRef<HTMLDivElement>(null);
  const [showConversionModal, setShowConversionModal] = useState(false);
  const [conversationData, setConversationData] = useState<any>();
  const [nextData, setNextData] = useState<any>();
  const [emoji, setEmoji] = useState<any>("");
  const [userCredits, setUserCredits] = useState<any>("");
  const [convLoading, setconvLoading] = useState(false);
  const [header, setHeader] = useState({
    authorization: localStorage.getItem("token"),
  });
  const token = localStorage.getItem("token");
  const userDetails = localStorage.getItem("userDetails");
  const [isDragging, setIsDragging] = useState(false);
  const [filePreviews, setFilePreviews] = useState<FilePreview[]>([]);

  const [showPromptTemplates, setShowPromptTemplates] = useState(false);
  //For Cancelling current ajax request
  const abortControllerRef = useRef<AbortController | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  //For Cancelling current ajax request
  // For cancelling Timeout
  const [autoRefreshTimeout, setAutoRefreshTimeout] = useState<NodeJS.Timeout | null>(null);
  // For cancelling Timeout

  interface ProgressUpdate {
    _id: number;
    type: "progress-update";
    steps_completed: number;
    total_steps: number;
    step_names_completed: string[];
    timestamp: string;
}

interface ChainSuccess {
    _id: number;
    type: "chain-success";
    output: {
        status: string;
        errors: any[];
        output: {
            answer: string;
            prompt: string;
            user_key_used: boolean;
            validation_history: any[];
            credits_cost: number;
            debug: {
                memory: any[];
                llm_requests: any[];
                llm_responses: any[];
            };
            history_items: any[];
            model_used: string;
        };
        credits_used: Array<{
            credits: number;
            name: string;
            multiplier?: number;
            num_units?: number;
            tool_run_id?: string;
            tool_name?: string;
            tool_id?: string;
        }>;
        executionTime: number;
    };
}

type Update = ProgressUpdate | ChainSuccess;

interface ParsedResult {
    type: "complete" | "inprogress" | "failed";
    updates: Update[];
    last_message_id: number;
}

  const copyToMessageBox = (template: string) => {
    setQuestion(template);
    setShowPromptTemplates(false);
  };

  const handleDragEnter = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };
  
  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };
  
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  interface FilePreview {
    id: string;
    file: File;
    preview: string;
    uploading: boolean;
    uploaded: boolean;
    url?: string;
  }

  useEffect(() => {
    // Cleanup previews on unmount
    return () => {
      filePreviews.forEach(preview => {
        if (preview.preview.startsWith('blob:')) {
          URL.revokeObjectURL(preview.preview);
        }
      });
    };
  }, [filePreviews]);
  
  const createFilePreview = (file: File): FilePreview => ({
    id: Math.random().toString(36).substr(2, 9),
    file,
    preview: file.type.startsWith('image/') 
      ? URL.createObjectURL(file) 
      : `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/></svg>')}`,
    uploading: false,
    uploaded: false
  });
  
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    
    if(e.target.files && e.target.files.length > 0) {
      const files = Array.from(e.target.files) as File[];
      const newPreviews = files.map((file: File) => createFilePreview(file));
      setFilePreviews(prev => [...prev, ...newPreviews]);
      
      // Upload each file and add its URL to message
      newPreviews.forEach(preview => {
        uploadFile(preview);
      });
    }
  };
  
  const handleDrop = async (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    
    const files = Array.from(e.dataTransfer.files);
    const newPreviews = files.map(createFilePreview);
    setFilePreviews(prev => [...prev, ...newPreviews]);
    
    // Upload each file
    for (const preview of newPreviews) {
      await uploadFile(preview);
    }
  };
  
  const uploadFile = async (preview: FilePreview) => {
    setFilePreviews(prev => 
      prev.map(p => p.id === preview.id ? {...p, uploading: true} : p)
    );
  
    const formData = new FormData();
    formData.append("file", preview.file);
    
    if (token) {
      try {
        const response = await axios.post("https://breezeminds.ocuss.app/upload.php", formData);
        const url = response?.data?.data?.url;
        
        setFilePreviews(prev => 
          prev.map(p => p.id === preview.id ? {...p, uploading: false, uploaded: true, url} : p)
        );
        
        // Add file URL to message box
        const fileMessage = `here is the file :${preview.file.name}  ${url}`;
        setQuestion(prev => {
          const newMessage = prev ? `${prev}\n${fileMessage}` : fileMessage;
          return newMessage;
        });
  
      } catch (error) {
        toast.error(`Failed to upload file: ${preview.file.name}`);
        setFilePreviews(prev => prev.filter(p => p.id !== preview.id));
      }
    } else {
      toast.error("Invalid token");
      setFilePreviews(prev => prev.filter(p => p.id !== preview.id));
    }
  };
  
  const removeFile = (previewId: string) => {
    const preview = filePreviews.find(p => p.id === previewId);
    
    // Remove file URL from message box
    if (preview?.url) {
      const fileMessage = `here is the file :${preview.file.name}  ${preview.url}`;
      setQuestion(prev => {
        // Handle both cases: URL at the end or in the middle of the message
        return prev
          .replace(`${fileMessage}\n`, '') // If URL is followed by newline
          .replace(fileMessage, '')         // If URL is at the end
          .trim();                          // Clean up any extra whitespace
      });
    }
  
    // Clean up preview
    setFilePreviews(prev => {
      const preview = prev.find(p => p.id === previewId);
      if (preview?.preview.startsWith('blob:')) {
        URL.revokeObjectURL(preview.preview);
      }
      return prev.filter(p => p.id !== previewId);
    });
  };
  

  // Function to get the value of a specific cookie by its name
  const getCookie = (name: string): string | null => {
    const value = `; ${document.cookie}`; // Add semicolon to handle cookie parsing
    const parts = value.split(`; ${name}=`); // Split cookie string
    if (parts.length === 2) {
        return parts.pop()?.split(';').shift() || null; // Return cookie value or null if not found
    }
    return null; // Return null if cookie is not found
  };

  const cookieValue = getCookie('wp_logged_in'); 
  
  const handleShowModal = (covData: any, nextConv: any, idx: number) => {
    const nextCovData = JSON.parse(JSON.stringify(nextConv))
      .splice(idx)
      ?.find((ele: any) => ele?.content?.message?.role === "action-response");
    setConversationData(covData);
    setNextData(nextCovData);
    setShowConversionModal(true);
  };
  const handleCloseModal = () => setShowConversionModal(false);  
  const homepageURL = packageJson.homepage; 
  useEffect(() => {
    checkUserCredits();
  }, []);

  const loadConversationList = () => {
   
    if (token) {       
      const formData = new FormData(); 
      formData.append("action", "oag_get_user_tasks");
      axios
        .post(
          homepageURL+"wp-admin/admin-ajax.php",
          formData            
        )
        .then((response) => {
          if(response?.data?.success == true)
            {             
              let parsedResult = JSON.parse(response?.data?.data?.body);
              setQuestionList(parsedResult?.results);
            }
         // setQuestionList(response.data.results);
        })
        .catch((error: any) => {
          if(cookieValue)
            {
                toast.error("Something went wrong");
            }
        });
    }
  };

  function checkUserCredits() {
    try {
      const formData = new FormData(); 
      formData.append("action", "oag_get_user_credits");
      axios
        .post(
          homepageURL+"wp-admin/admin-ajax.php",formData,          
        )
        .then((res: any) => {         
                    
          if(res?.data?.success == true)
          {             
            let credits = res?.data?.data?.credits;           
            // const userCreditDiv: any = document.getElementById("user-credits");
            // userCreditDiv.innerHtml = '<b>Credits : '+credits+'</b>';
            setUserCredits(credits);
            
            if(credits>=10)
            {
             
              handleCreditsCheck(true);
            }else{
              
              handleCreditsCheck(false);
            }
          }
          
        })
        .catch((err: any) => {
          //console.log(err);
          if(cookieValue)
          {
              toast.error("Something went wrong");
          }
          
        });
      //const hasEnoughCredits = response.data.credits > 0;
      //handleCreditsCheck(hasEnoughCredits);
    } catch (error) {
      console.error("Failed to check user credits:", error);
      // Optionally handle error (e.g., show a generic error message)
    }
  }

  function handleCreditsCheck(hasEnoughCredits: boolean) {
    const textarea = document.getElementById("text-message") as HTMLTextAreaElement;
    const creditWarning = document.getElementById("credit-warning") as HTMLParagraphElement;
    const btn_submit = document.getElementById("btn_submit") as HTMLButtonElement;
  
    if (!hasEnoughCredits) {
      // Disable the textarea
      textarea.disabled = true;
      btn_submit.disabled = true;
  
      // Show the warning message
      creditWarning.style.display = "block";
      creditWarning.style.textAlign = "center";
      creditWarning.style.marginTop = "10px";
      creditWarning.style.color = "red";
      
    } else {
      // Enable the textarea (just in case it was previously disabled)
      textarea.disabled = false;
      btn_submit.disabled = false;
      // Hide the warning message
      creditWarning.style.display = "none";

    }
  }
  
  useEffect(() => {
    const userCreditDiv: any = document.getElementById("user-credits");
    userCreditDiv.innerHtml = '<b>Credits : '+userCredits+'</b>';
    if(parseInt(userCredits, 10) <= 50)
    {
      userCreditDiv.style.color = 'red';
    }else{
      userCreditDiv.style.color = 'inherit';
    }
    
  }, [userCredits]);

  useEffect(() => {
    const add_icon: any = document.getElementById("add_icon");
 
   if(add_icon){
    //console.log("in add_icon"+ loading);
      if(loading === true)
      {
        //console.log("in true"+ loading);
        add_icon.style.display = 'none';
      }else{
        //console.log("in false"+ loading);
        add_icon.style.display = 'inherit';
      }
    }
    
  }, [loading]);

  useEffect(() => {
    const loading_circle: any = document.getElementById("loading_circle");
    if(convLoading == true){     
      loading_circle.style.display = "block";
    }else{
      loading_circle.style.display = "none";
    }
  }, [convLoading]);

  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [data]);

  useEffect(() => {
    if (!token) {
      setTimeout(() => {
          const token = localStorage.getItem("token");
          setHeader({ authorization: token });
      }, 2000);
    } else {
      setHeader({ authorization: token });
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      const formData = new FormData(); 
      formData.append("action", "oag_get_agent_details");
      axios
        .post(
          homepageURL+"wp-admin/admin-ajax.php",formData,          
        )
        .then((res: any) => {         
                    
          if(res?.data?.success == true)
          {             
            let agentDetails = JSON.parse(res?.data?.data?.body);
             setEmoji(agentDetails?.agent?.emoji);
          }
          
        })
        .catch((err: any) => {
          if(cookieValue)
            {
                toast.error("Something went wrong");
            }
          
        });
      if (token) {
       
        const formData = new FormData(); 
        formData.append("action", "oag_get_user_tasks");
        axios
          .post(
            homepageURL+"wp-admin/admin-ajax.php",
            formData            
          )
          .then((response) => {
            if(response?.data?.success == true)
              {             
                let parsedResult = JSON.parse(response?.data?.data?.body);
                setQuestionList(parsedResult?.results);
              }
           // setQuestionList(response.data.results);
          })
          .catch((error: any) => {
            if(cookieValue)
              {
                  toast.error("Something went wrong");
              }
          });
      }
    }
  }, [header, isCreateTask]);

  useEffect(() => {
    if (jobId !== "") {
      let interval: any;
      let isFetching = false;

      // Create cleanup function to handle cancellation
      const cleanup = () => {
        if (abortControllerRef.current) {
          //console.log("inside abort condition in cleanup fun");
          //console.log(abortControllerRef.current);
          abortControllerRef.current.abort();
          abortControllerRef.current = null;
        }

        if (intervalRef.current) {
          //console.log("inside Interval condition in cleanup fun");
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          //console.log("Interval is cleared");
        }
     
        isFetching = false;
      };

      const fetchData = async () => {
        if (isFetching) return; // Skip if already fetching
        isFetching = true;
        try {
          // Cancelling existing ajax requests
          // Cancel any existing request
          if (abortControllerRef.current) {
            abortControllerRef.current.abort();
          }
          // Create new AbortController for this request
          abortControllerRef.current = new AbortController();
          // Cancelling existing ajax requests
          if (token) {
            const formData = new FormData(); 
            formData.append("action", "oag_request_task_status");
            formData.append("job_id", jobId);
            await axios
              .post(
                homepageURL+"wp-admin/admin-ajax.php",
                formData, 
                {
                  signal: abortControllerRef.current.signal // Add abort signal
                }
              )
              .then((response: any) => {
                if(response?.data?.success == true)
                  {     
                      let parsedResult = JSON.parse(response?.data?.data?.body); 
                      console.log('status check'+ parsedResult?.updates);
                      console.log('status check'+ parsedResult?.updates[1]);
                      console.log('status check'+ parsedResult?.updates[1]?.output);
                      //if (parsedResult?.updates[1]?.output?.status === "complete") {
                      //   if (parsedResult?.type === "complete" && parsedResult?.updates?.length > 0) {
                      //     const chainSuccess = parsedResult.updates.find(update => update.type === "chain-success");
                      //     if (chainSuccess?.output?.status === "complete") {
                      //       const content = {
                      //         content: chainSuccess.output.output.answer,
                      //         role: "agent",
                      //         chainConfig: [],
                      //       };
                      //   // const content = {
                      //   //   content: parsedResult?.updates[1]?.output?.output?.answer,
                      //   //   role: "agent",
                      //   //   chainConfig: [],
                      //   // };
                      //   // setData([
                      //   //   ...data,
                      //   //   { content: content },
                      //   // ]);
                      //   isFetching = false;
                      //   handleConvClick(conversationId, false);
                      //   setLoading(false);
                      //   //Undo Comment
                      //   //clearInterval(interval);
                      //   //END Undo Comment
                      //   // Cancelling existing ajax request
                      //   //cleanup(); // Use cleanup function
                      //   // Cancelling existing ajax request
                      //   }
                      // } 
                      if (parsedResult?.type === "complete") {
                        const chainSuccess = parsedResult.updates.find(
                            (update: Update): update is ChainSuccess => update.type === "chain-success"
                        );
                        
                        if (chainSuccess?.output?.status === "complete") {
                            const content = {
                                content: chainSuccess.output.output.answer,
                                role: "agent",
                                chainConfig: [],
                            };
                            isFetching = false;
                            handleConvClick(conversationId, false);
                            setLoading(false);
                            clearInterval(interval);
                        }
                    }
                      else if (parsedResult?.type === "failed") {
                        toast.error("Something went wrong");
                        isFetching = false;
                        setLoading(false);
                        //Undo Comment
                        //clearInterval(interval);
                        //END Undo Comment
                          // Cancelling existing ajax request
                          cleanup(); // Use cleanup function
                          // Cancelling existing ajax request
                      }

                  }
                
              })
              .catch((error: any) => {
                //Cleaning existing ajax requests
                 // Don't show error for cancelled requests
                 if (error.name === 'CanceledError') {
                  //console.log('Request was cancelled');
                } else {
                  toast.error("Something went wrong");
                }
                //Cleaning existing ajax requests
                //Undo Comment
                // toast.error("Something went wrong");
                //Undo Comment
              });
          } else {
            toast.error("Invalid token");
          }
        } catch (error: any) {
          //Cancelling existing requests
          // Don't show error for cancelled requests
          if (error.name === 'CanceledError') {
            //console.log('Request was cancelled');
          } else {
            toast.error("Something went wrong");
            cleanup(); // Use cleanup function
          }
          //Cancelling existing requests
          //Undo Comment
          // toast.error("Something went wrong");
          // clearInterval(interval);
          //End Undo Comment
        } finally {
          isFetching = false;
        }
      };

      intervalRef.current = setInterval(fetchData, 3000);
      // interval = setInterval(fetchData, 3000);
      // Cancelling existing ajax requests
       // Return cleanup function for useEffect
       return () => {
        cleanup();
      };
      // Cancelling existing ajax requests
      //Undo Comment
      //return () => clearInterval(interval);
      //END Undo Comment
    }
  }, [jobId]);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (loading) return;
    const regex = /^\s*$/.test(question);
    if (!regex || file) {
     
      
      const formData = new FormData(); 
      formData.append("action", "oag_create_task");
      formData.append("message", question);

      const textarea: any = document.getElementById("text-message");
      textarea.style.height = "54px";
      setQuestion("");
      // Clear file previews
      setFilePreviews([]);
      setLoading(true);
      // item?.content?.message?.content
      const content = { message: { content: question, role: "user" } };
      setData([
        ...data,
        { content: content, insert_date_: moment().toISOString() },
      ]);
      if (isInitial) {
        if (token) {
          axios
            .post(
              homepageURL+"wp-admin/admin-ajax.php",
              formData
            )
            .then((response) => {
              if(response?.data?.success == true)
                {     
                    let parsedResult = JSON.parse(response?.data?.data?.body); 
                    setJobId(parsedResult?.job_info?.job_id);
                    setConversationId(parsedResult?.conversation_id);
                    setIsInitial(false);
                    setIsCreateTask(true);  
                    setTimeout(loadConversationList, 1000);

                }
             
            })
            .catch((error: any) => {
                const errmessage =
                error?.response?.data?.data?.message ||
                error?.response?.data?.message ||
                "Something went wrong";
                console.log('error : '+ errmessage);
              toast.error(errmessage);
            });
        } else {
          toast.error("Invalid token");
        }
      } else {
      
        formData.append("conversation_id", conversationId);
        if (token) {
          axios
            .post(
              homepageURL+"wp-admin/admin-ajax.php",
              formData
            )
            .then((response) => {
              if(response?.data?.success == true)
                {     
                    let parsedResult = JSON.parse(response?.data?.data?.body); 
                    setJobId(parsedResult?.job_info?.job_id);
                    setIsInitial(false);
                    setTimeout(loadConversationList, 1000);

                }

               
             
            })
            .catch((error: any) => {
              toast.error("Something went wrong");
            });
        } else {
          toast.error("Invalid token");
        }
      }
    }
  };

  const handleCreateTask = () => {
    checkUserCredits();
    setData([]);
    setConversationId("");
    setActiveConv("");
    setCurrentConv("");
    setIsInitial(true);
  };

  const handleConvClick = (
    knowledge_set: string,
    convClick: boolean,
    title?: string
  ) => {
     // Cancel any ongoing requests before switching conversations
     if (abortControllerRef.current) {
     
      //console.log("inside abort condition in handleconv");
      //console.log(abortControllerRef.current);
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
      
    }
    if (intervalRef.current) {
      //console.log("inside abort intervalRef in handleconv");
      clearInterval(intervalRef.current);
      intervalRef.current = null;
  }
    // Clear File Previews
    setFilePreviews([]);

    // Then in handleConvClick function, before setting new timeout:
    if (autoRefreshTimeout) {
      clearTimeout(autoRefreshTimeout);
      setAutoRefreshTimeout(null);
    }
    setCurrentConv(title);
    setActiveConv(knowledge_set);
    if (convClick) {
      setData([]);
      setQuestion("");
      setLoading(false);
      setconvLoading(true);
    }

    //console.log("abort object set for handleconvclick ajax");
    abortControllerRef.current = new AbortController();

    knowledge_set = knowledge_set;
    const payload = {
      knowledge_set: knowledge_set,
      filters: [],
      sort: [
        {
          insert_date_: "asc",
        },
      ],
      page_size: 1000,
    };
    if (token) {
      checkUserCredits();
      const formData = new FormData(); 
      formData.append("action", "oag_get_user_conversation_details");
      formData.append("conversation_id", knowledge_set);
      console.log('Conversation Detail Called');
      axios
        .post(
          homepageURL+"wp-admin/admin-ajax.php",
          formData,
          {
            signal: abortControllerRef.current.signal // Add abort signal to this request
          }
        )
        .then((response) => {
          const resData: any = [];
          console.log('Conversation Detail response'+ response?.data?.success);
          if(response?.data?.success == true)
            {             
              let parsedResult = JSON.parse(response?.data?.data?.body);             
              parsedResult?.results.map((item: any, index: number) => {
                if (index !== 0) {
                  let role = item?.data?.message?.role;
                  //console.log(role);
                  if (!convClick) {
                    if (index > data.length) {
                      resData.push({
                        content: item?.data,
                        insert_date_: item?.insert_date_,
                      });
                    }
                  } else {
                   // console.log("index is "+index+" data length" + (data.length));
                    //console.log("index is "+index+" item length" + (parsedResult?.results.length));
                    resData.push({
                      content: item?.data,
                      insert_date_: item?.insert_date_,
                    });

                    if (autoRefreshTimeout) {
                      clearTimeout(autoRefreshTimeout);
                      setAutoRefreshTimeout(null);
                    }

                     if(index == (parsedResult?.results.length -1))
                      {
                        //console.log("index is equal to data length");
                        if(role == 'action-request' || role == 'action-confirm' || role == 'action-response')
                        {
                          //console.log("Timeout function called.");
                          const timeoutId = setTimeout(() => {
                            handleConvClick(knowledge_set, true);
                        }, 30000);
                        setAutoRefreshTimeout(timeoutId);
                           //console.log("Aftr Timeout called.");
                        }
                        
                      }
                  }
                }
              });
            }
         
          setData((preArray: any) => [...preArray, ...resData]);
          setIsInitial(false);
          setConversationId(knowledge_set);
          setconvLoading(false);
        })
        .catch((error: any) => {
           // Don't show error toast if request was cancelled
           if (error.name === 'CanceledError') {
              //console.log('Conversation details request cancelled');
          } else {
              toast.error("Error fetching conversation");
          }
          setconvLoading(false);
        });
    } else {
      toast.error("Invalid token");
      setconvLoading(false);
    }
  };

  const isDisabled = () => {
    const regex = /^\s*$/.test(question);
    const isFileUploaded = file ? false : true;
    const shouldDisabled = isFileUploaded ? regex : isFileUploaded;
    return loading ? true : shouldDisabled;
  };
  const handleFileChange = (e: any) => {
    e.preventDefault();
    
    if(typeof e.target.files[0] !== 'undefined')
    {
      const selectedFile = e?.target?.files[0];
      setFile(e.target.files[0]);
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      if (token) {
        axios
          .post("https://breezeminds.ocuss.app/upload.php", formData)
          .then((response) => {
            if (!question || question === "") {
              const data = `here is the file :${selectedFile.name}  ${response?.data?.data?.url}`;
              setQuestion(data);
            } else {
              const data = `here is the file :${selectedFile.name}  ${response?.data?.data?.url}`;
              // setChips([...chips, selectedFile.name]);
              setQuestion((prev) => prev + "\n" + data);
            }
            // payload.content = response?.data?.data?.url;
            setFile(null);
          })
          .catch((error: any) => {
            toast.error("Something went wrong");
            setLoading(false);
          });
      } else {
        toast.error("Invalid token");
      }
    }
   
  };

  const formatTimeDifference = (date: any) => {
    const givenTime: any = new Date(date);
    const currentTime: any = new Date();

    const diffInSeconds = (currentTime - givenTime) / 1000;
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInSeconds / 3600);
    const diffInDays = Math.floor(diffInSeconds / 86400);

    if (diffInSeconds < 60) {
      return `${Math.floor(diffInSeconds)} second${
        diffInSeconds !== 1 ? "s" : ""
      } ago`;
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes !== 1 ? "s" : ""} ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
    } else if (diffInHours < 48) {
      return "Yesterday";
    } else {
      return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
    }
  };

  const handleFocus = () => {
   
   // console.log("Textarea is focused!");
    checkUserCredits();
  };

  const handlefChange = (e: any) => {
    
    if (e.key !== "Enter") {
      setQuestion(e.target.value);
    }
    const textarea: any = document.getElementById("text-message");
    
    const scrollHeight = textarea.scrollHeight;
    
    if(scrollHeight >54)
    {
      textarea.style.height = "auto";
      const textareaScriollHeight = textarea.scrollHeight;
      textarea.style.height = `${Math.min(textareaScriollHeight, 300)}px`;
    }
    
    // Calculate the new height
    // textarea.style.height = `${Math.min(textarea.scrollHeight, 120)}px`;
    // Calculate the position offset for expanding upwards
    // textarea.style.bottom = `-${textarea.scrollHeight - textarea.clientHeight}px`;
    if (e.target.value === "") {
      // textarea.style.height = "54px";
      textarea.style.height = "54px"; // Reset to base height if empty
    textarea.style.bottom = "0px"; // Reset position
    }
  };

  const handlefKeyDown = (e: any) => {
    if (e.key === "Enter" && e.shiftKey) {
      handleSubmit(e);
    } else if (e.key === "Enter" && question !== "") {
      e.preventDefault();
      const textarea = e.target as HTMLTextAreaElement;
      const startPos = textarea.selectionStart;
      const endPos = textarea.selectionEnd;
  
      // Update the question state with the new line
      setQuestion((prev) => {
        const before = prev.substring(0, startPos);
        const after = prev.substring(endPos);
        return before + "\n" + after;
      });
  
      // Use setTimeout to ensure the textarea is updated before resizing
      setTimeout(() => {
        const textarea = e.target as HTMLTextAreaElement;
        textarea.style.height = "auto";
        const scrollHeight = textarea.scrollHeight;
        textarea.style.height = `${Math.min(scrollHeight, 300)}px`;
  
        // Calculate line height
        const lines = textarea.value.split('\n');
        const lineHeight = textarea.scrollHeight / lines.length;
  
        // Find the cursor position
        //const cursorLine = textarea.value.substring(0, startPos).split('\n').length - 1;
        const cursorLine = textarea.value.substring(0, startPos).split('\n').length;
        const cursorOffset = cursorLine * lineHeight;
  
        // Ensure the cursor is visible
        const viewportHeight = textarea.clientHeight;
        const scrollTop = cursorOffset - viewportHeight / 2;
  
        // Set scrollTop to ensure the cursor is visible
        textarea.scrollTop = Math.max(0, scrollTop);
  
        // Correct cursor position handling
        textarea.selectionStart = startPos + 1;
        textarea.selectionEnd = startPos + 1;
      }, 0);
    }
  };
  
  

const handlePaste = (e: any) => {
  const textarea = e.target;
  const startPos = textarea.selectionStart;
  const endPos = textarea.selectionEnd;
  setTimeout(() => {
    textarea.style.height = "auto";
    
    const scrollHeight = textarea.scrollHeight;
    textarea.style.height = `${Math.min(scrollHeight, 300)}px`;

    textarea.style.bottom = `-${scrollHeight - textarea.clientHeight}px`;
    textarea.style.overflowY = "auto";

    // textarea.selectionStart = startPos + 1;
    // textarea.selectionEnd = startPos + 1;

        // Restore the cursor position after the paste
        // const pastedTextLength = (textarea.value.length - (endPos - startPos));
        // textarea.selectionStart = startPos + pastedTextLength;
        // textarea.selectionEnd = startPos + pastedTextLength;
}, 0);
}
// const handleLinkClick = (event: { target: any; preventDefault: () => void; }) => {
//   const target = event.target;
//   if (target.tagName === "A" && target.href) {
//     event.preventDefault();
//     // Open the link directly in a new tab
//     window.open(target.href, '_blank');
//   }
// };

const handleLinkClick = (event: { target: any; preventDefault: () => void; }) => {
  let target = event.target;
  
    // Traverse up the DOM tree to find the closest anchor tag
    while (target !== null && target.tagName !== 'A') {
      target = target.parentElement;
    }
   
  if (target !== null && target.tagName === "A" && target.href) {
    event.preventDefault();
// Open the link directly in a new tab
const linkLabel = target.textContent || target.innerText;
openLinkInIframe(target.href,linkLabel);
  }
};

const handleDeleteConversation = (id: string) => {
 

 const del_loading_gif: any = document.getElementById("del_loading_gif_"+id);
 const delete_button: any = document.getElementById("delete-button-"+id);
 del_loading_gif.style.display="block";
 delete_button.style.display="none";

 //console.log("Conversation ID: "+ conversationId)

  const formData = new FormData(); 
      formData.append("action", "oag_delete_conversation");
      formData.append("conversation_id", id);
      
      axios
        .post(
          homepageURL+"wp-admin/admin-ajax.php",
          formData
        )
        .then((response) => {
          const resData: any = [];
          if(response?.data?.success == true)
            {             
                if(response?.data?.data?.status_code == 200)
                {                   
                  toast.success("Conversation deleted successfully.");  
                  loadConversationList();
                  if(conversationId == id)
                  {
                    setData([]);
                    setConversationId("");
                    setActiveConv("");
                    setCurrentConv("");
                    setIsInitial(true); 
                  }
                                
                }else{
                  toast.error("Something went wrong.");
                }

            }
            del_loading_gif.style.display="none";
            delete_button.style.display="block";
        
        })
        .catch((error: any) => {
          toast.error("Error fetching conversation");
          del_loading_gif.style.display="none";
          delete_button.style.display="block";
        });
  // Example: Update your state or send a request to save the title
};


const handleSaveTitle = (id: string, newTitle: string) => {
  // Implement the logic to save the new title
 // console.log(`Saving title for ${id}: ${newTitle}`);
  const formData = new FormData(); 
      formData.append("action", "oag_update_title");
      formData.append("conversation_id", id);
      formData.append("title", newTitle);
      axios
        .post(
          homepageURL+"wp-admin/admin-ajax.php",
          formData
        )
        .then((response) => {
          const resData: any = [];
          if(response?.data?.success == true)
            {             
                if(response?.data?.data?.status_code == 200)
                {
                  // add a code
                  if(conversationId == id)
                  {
                    setCurrentConv(newTitle);
                  }                  
                  setTimeout(loadConversationList, 1000);
                 
                }else{
                  toast.error("Something went wrong.");
                }

            }
         
        
        })
        .catch((error: any) => {
          toast.error("Error fetching conversation");
        });
  // Example: Update your state or send a request to save the title
};


const openLinkInIframe = (url: string,linkLabel:string) => {
  const iframeContainer = document.getElementById("iframeContainer");
 // url = "https://citest123.xyz/rendr.php";
  if (iframeContainer) {   

   
    iframeContainer.innerHTML = ""; // Clear previous content
    iframeContainer.style.display = "block"; // Show
    iframeContainer.style.borderRadius = "15px"; // Clear previous content

    const iframeLabel = document.createElement("div");
    iframeLabel.innerHTML = linkLabel;   
    iframeLabel.classList.add('col-md-8');
    iframeLabel.style.paddingLeft="20px";
    iframeLabel.style.fontSize="18px";

    const iframeLabelWrapper = document.createElement("div");
    iframeLabelWrapper.style.display = "flex";
    iframeLabelWrapper.style.alignItems = "center";
    iframeLabelWrapper.style.borderBottom = "solid 1px lightgray";
    iframeLabelWrapper.style.background = "#d0c5e1";
    
    // Create the iframe
    const iframe = document.createElement("iframe");
    iframe.src = url;
    iframe.style.width = "100%";
    iframe.style.height = "85%";
    iframe.style.border = "none";
   // iframe.style.marginTop  = "70px";
    iframe.style.borderTop  = "solid 1px ligtgrey";

   
   

     // Create a close button
     const closeIcon = document.createElement("img");
     closeIcon.src = close_icon;    
     closeIcon.style.top = "10px";
     closeIcon.style.right = "20px";
     closeIcon.style.zIndex = "1001";    
     closeIcon.style.color = "white";
     closeIcon.style.border = "none";
     closeIcon.style.padding = "10px";
     closeIcon.style.cursor = "pointer";
     closeIcon.style.width = "50px";

     const closeIconWrapper = document.createElement("div");
     closeIconWrapper.style.display = "flex";
     closeIconWrapper.style.justifyContent = "end";
     closeIconWrapper.classList.add('col-md-1');
     
 
     closeIcon.addEventListener("click", () => {
      // iframeContainer.style.zIndex = "-1"; // Hide the iframe
      iframeContainer.style.display = "none";
       iframeContainer.innerHTML = ""; // Clear content
     });

     // Create a new window button
     const newWindow = document.createElement("a");
     newWindow.textContent = "Unable to load? Click Here to open in a new window.";
     newWindow.target = "_blank";
     newWindow.href = url;   
     newWindow.style.top = "10px";
     newWindow.style.right = "100px";
     newWindow.style.zIndex = "1001";    
     newWindow.style.color = "#401979";
     newWindow.style.border = "none";
     newWindow.style.padding = "10px";
     newWindow.style.cursor = "pointer";
     newWindow.style.fontSize = "14px";

     const external_link_html = document.createElement("img");
     external_link_html.src = external_link;
     external_link_html.style.width = "12px";
     external_link_html.style.marginLeft = "5px";
   

     newWindow.appendChild(external_link_html);

     const newWindowWrapper = document.createElement("div");
     newWindowWrapper.style.display = "flex";
     newWindowWrapper.style.justifyContent = "end";
     newWindowWrapper.classList.add('col-md-3');

 
     newWindow.addEventListener("click", () => {
      //  iframeContainer.style.zIndex = "-1"; // Hide the iframe
      //  iframeContainer.innerHTML = ""; // Clear content
     });

    // Style and display the iframe container
    iframeContainer.style.position = "fixed";
    iframeContainer.style.top = "50%";
    iframeContainer.style.left = "50%";
    iframeContainer.style.transform = "translate(-50%, -50%)";
    iframeContainer.style.width = "80%"; // or any desired width
    iframeContainer.style.height = "80%"; // or any desired height
    iframeContainer.style.zIndex = "1000"; // Show the iframe
    iframeContainer.style.backgroundColor = "white";
    iframeContainer.style.boxShadow = "0 0 10px rgba(0, 0, 0, 0.5)";
    
    // Append the iframe and close button to the container
    iframeLabelWrapper.appendChild(iframeLabel); 
    newWindowWrapper.appendChild(newWindow); 
    closeIconWrapper.appendChild(closeIcon); 

    iframeLabelWrapper.appendChild(newWindowWrapper); 
    iframeLabelWrapper.appendChild(closeIconWrapper); 


    iframeContainer.appendChild(iframeLabelWrapper);
    iframeContainer.appendChild(iframe);
  
  } else {
    console.error("iframeContainer element not found");
  }
};




  return (
    <div className="chat-box-container dricus_app_container">
    <div className="chat_view" id="chat_view">
   
      <div className="chat_section">
        <div className="panel_wrapper">
          <ConvList
            questionList={questionList}
            activeConv={activeConv}
            handleCreateTask={handleCreateTask}
            handleConvClick={handleConvClick}
            formatTimeDifference={formatTimeDifference}
            onSaveTitle={handleSaveTitle} 
            deleteConversation={handleDeleteConversation} 
          />
          <div className="right_panel panel">
            <div className="right_panel_inner">
              <div className="message">
                <div className="message_inner ">
                  <div className="profile_top">
                    <div className="left_part">
                      <span className="chat_img">
                        <img src={emoji ? emoji : user} alt="User" />
                      </span>
                      <div className="chat_detail">
                        <div className="chat_title">
                          {currentConv ? currentConv : "BreezeMind (Beta)"}
                        </div>
                      </div>
                    </div>
                    <div className="right_part" id="user-credits"><b>Credits : {userCredits}</b></div>
                
                  </div>
                  <div className="loading_circle" id="loading_circle"><img src={loading_circle}></img></div>
                  <div className="profile_bottom">
                    <div className="chat">
                      {data.map((item: any, index: number) => {
                        return (
                          <div
                            className="chat_wrapper"
                            ref={
                              index === data.length - 1 ? lastMessageRef : null
                            }
                          >
                            {item?.content?.message?.role === "user" && (
                              <div className="chat_message">
                                <div className="top_part">
                                  <div className="user_icon">
                                    <img src={user2} alt="User" />
                                  </div>
                                  <div className="msg_info">
                                    <div className="msg_txt">
                                      <span>You</span>
                                      <span className="msg_time">
                                        {formatTimeDifference(
                                          item?.insert_date_
                                        )}
                                      </span>
                                    </div>
                                    <div className="msg_sub_text">
                                      <Markdown>
                                        {item?.content?.message?.content}
                                      </Markdown>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {loading && index === data.length - 1 && (
                              <>
                                <div className="chat_wrapper">
                                  <div className="chat_message">
                                    <div className="top_part msg_part">
                                      <div className="user_icon">
                                        <img src={emoji} alt="User" />{" "}
                                      </div>
                                      <div className="msg_loading">
                                        <span>BreezeMind</span> is Working <img src={loading_gif} className="loading_gif"></img>
                                        {/* {item?.content?.role === "agent" && item?.content?.content ?  <><span>BreezeMind</span> Provided an update:</>:<><span>BreezeMind</span> is Working...</>} */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                              {index === data.length - 1 && (item?.content?.message?.role === "action-request" || item?.content?.message?.role === "action-confirm" || item?.content?.message?.role === "action-response")  && (
                              <>
                                <div className="chat_wrapper">
                                  <div className="chat_message">
                                    <div className="top_part msg_part">
                                      <div className="user_icon">
                                        <img src={emoji} alt="User" />{" "}
                                      </div>
                                      <div className="msg_loading">
                                        <span>BreezeMind</span> is Working <img src={loading_gif} className="loading_gif"></img>
                                        {/* {item?.content?.role === "agent" && item?.content?.content ?  <><span>BreezeMind</span> Provided an update:</>:<><span>BreezeMind</span> is Working...</>} */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                          

                            {data?.length &&
                              item?.content?.message?.role ===
                                "action-request" &&
  item?.content?.message?.chain_config?.type === "tool" && (
                                <>
                                  <Accordion
                                    item={item}
                                    index={index}
                                    data={data}
                                    formatTimeDifference={formatTimeDifference}
                                    handleShowModal={handleShowModal}
                                  />
                                </>
                              )}
                            {item?.content?.message?.role === "agent" && (
                              <div className="chat_message chat_message-own">
                                <div className="top_part">
                                  <div className="user_icon">
                                    <img src={emoji} alt="User" />
                                  </div>
                                  <div className="msg_info">
                                    <div className="msg_txt">
                                      <span>BreezeMind</span>
                                      <span className="msg_time">
                                        {formatTimeDifference(
                                          item?.insert_date_
                                        )}
                                      </span>
                                    </div>
                                    <div className="msg_sub_text">
                                      {/* <Markdown>
                                        {item?.content?.message?.content}
                                      </Markdown> */}
                                      <div className="" onClick={handleLinkClick}>
                                        <Markdown>{item?.content?.message?.content}</Markdown>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                             <div id="iframeContainer" className="iframe_container"></div>
                          </div>
                        );
                      })}
                    </div>
                    <div id="credit-warning">You don't have enough credits left. Please <a href='/my-account/?section=my-subscriptions#add_on_credits'>upgrade your plan</a> or <a href='/my-account/?section=my-subscriptions#add_on_credits'>buy credits</a>.</div>
                    <div id="login-warning"></div>
                    <div className={`drag-drop-zone ${isDragging ? 'active' : ''}`}
                      
                    >
                      <div className="drop-message">
                        <h3>Drop Files Here</h3>
                        <p>Drop one or more files to upload</p>
                      </div>
                    </div>
                    <div className="chat_form" >
                      <form id="chat_form" onSubmit={handleSubmit} >
                        <div className="chat_form_inner">
                        {filePreviews.length > 0 && (
                            <div className="file-previews">
                              {filePreviews.map(preview => (
                                <div key={preview.id} className="file-preview">
                                  <img src={preview.preview} alt={preview.file.name} />
                                  {preview.uploading ? (
                                    <div className="upload-indicator">
                                      <img src={loading_gif} alt="uploading" style={{ width: '20px', height: '20px' }} />
                                    </div>
                                  ) : (
                                    <button 
                                      className="remove-file" 
                                      onClick={() => removeFile(preview.id)}
                                      aria-label="Remove file"
                                    >
                                      ×
                                    </button>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                          <div className="file_upload">
                            <input
                              type="file"
                              className="file"
                              id="myfile"
                              name="myfile"
                              multiple 
                              onChange={(e) => handleFileUpload(e)}
                            />
                            <img
                              className="file_icon"
                              src={attachment}
                              alt="File"
                            />
                          </div>
                          
                          <textarea
                            id="text-message"
                            className="form-control conversation-text-area"
                            placeholder="Type your message here. Press Enter (⏎) to add a new line or Shift + Enter (⇧ + ⏎) to send the message."
                            value={question}
                            onChange={handlefChange}
                            onFocus={handleFocus} 
                            onKeyDown={handlefKeyDown}
                            onPaste={handlePaste}
                            onDragEnter={handleDragEnter}
                            onDragLeave={handleDragLeave}
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}
                          />
                          <button
                            type="submit"
                            className="btn btn_submit"
                            id="btn_submit"
                            // onClick={(e) =>
                            //   question !== "" ? handleSubmit(e) : null
                            // }
                            disabled={isDisabled()}
                          >
                            <img src={btn_submit} alt="Send" />
                          </button>
                        </div>
                      </form>
                      <div id="dricus-disclaimer">Disclaimer: BreezeMind is currently in beta and may occasionally produce inaccurate or unexpected results.<br></br> We’re continuously improving its capabilities, but please verify any critical information generated by BreezeMind for complete accuracy.</div>
                    </div>
                    <ConversionModal
                      show={showConversionModal}
                      nextData={nextData}
                      conversationData={conversationData}
                      handleClose={handleCloseModal}
                      emoji={emoji}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="floating-buttons-container">
              <Button
                variant="primary"
                className="prompt-templates-button"
                onClick={() => setShowPromptTemplates(true)}
              >
                Prompt Templates
              </Button>
             
            </div> */}
          </div>
        </div>
      </div>
    </div>

    <div className="overlay" id="loginOverlay">
        <div className="overlay-content">
            <p>Please login to use BreezeMind.</p>
            <a href={`${homepageURL}wp-login.php`} className="dricus_login_link">Login</a>
        </div>
    </div>

    <PromptTemplatesModal
      show={showPromptTemplates}
      handleClose={() => setShowPromptTemplates(false)}
      copyToMessageBox={copyToMessageBox}
    />

    </div>
  );
}
